export const iconMap: Record<string, string> = {
  contract: 'pi pi-custom-file-check',
  schedule: 'pi pi-calendar',
  audit: 'pi pi-custom-clipboard-edit',
  findings: 'pi pi-custom-clipboard-results',
  financials: 'pi pi-money-bill',
  certificates: 'pi pi-custom-certified',
  notification: 'pi pi-bell',
  actions: 'pi pi-custom-check-list',
  organization: 'pi pi-cog',
  snowLink: 'pi pi-headphones',
  default: 'pi pi-cog',
  feedback: 'pi pi-megaphone',
};

export const feedback = 'Feedback';
